/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable no-case-declarations */
import { ReduxAction } from '..';
import {
  BUS_LIST_RESET,
  BUS_LIST_UPDATE,
  LOCATION_UPDATE,
  SOCKET_UPDATE,
  TRACKING_CHANNEL_RESET,
  TRACKING_CHANNEL_UPDATE,
} from '../constants';
import { ReducerState } from './_prototype';

const initialState: ReducerState = {
  socket: null,
  trackingChannel: '',
  locationUpdate: [],
  busList: [],
};

export default function actionReducer(
  state = initialState,
  action: ReduxAction
) {
  switch (action.type) {
    case SOCKET_UPDATE:
      return {
        ...state,
        socket: action.payload,
      };

    case TRACKING_CHANNEL_UPDATE:
      return {
        ...state,
        trackingChannel: action.payload,
      };
    case TRACKING_CHANNEL_RESET:
      return {
        ...state,
        trackingChannel: [],
      };

    case BUS_LIST_UPDATE:
      return {
        ...state,
        busList: action.payload,
      };
    case BUS_LIST_RESET:
      return {
        ...state,
        busList: [],
      };

    case LOCATION_UPDATE:
      const data = [...state.locationUpdate];
      const idx = data.findIndex(
        (x) => x.vehicleId === action.payload.vehicleId
      );
      if (idx > -1) {
        data[idx] = {
          ...data[idx],
          ...action.payload,
        };
      } else {
        data.push(action.payload);
      }
      return {
        ...state,
        locationUpdate: data,
      };
    default:
      return state;
  }
}
